// A meeting's / template's sections (SectionsJSON). hideBoard: Run Meeting hides the board while the section is on.
// Sections saved before hideBoard existed hid the board whenever they showed the scorecard or rocks, so that's
// their default (API meetings.ts sanitizeSections does the same).
export function sectionHidesBoard(section: any): boolean {
    return section.hideBoard ?? !!(section.showScorecard || section.showRocks);
}

export function parseSections(json: string | null | undefined): any[] {
    const sections = json ? JSON.parse(json) : [];
    return sections.map((s: any) => ({ ...s, hideBoard: sectionHidesBoard(s) }));
}

export function newSection(): any {
    return { name: '', minutes: 5, description: '', showScorecard: false, showRocks: false, hideBoard: false };
}
